import api from "./../api";
import UtilsUrl from "../../utils/UtilsUrl";

class ConfigLivraisonService {
  saveConfigLivraison(model) {
    return api.post(UtilsUrl.LivraisonPosURL() + "/saveConfigLivraison", model);
  }

  getDeliveryInformation(idUser) {
    return api.get(
      UtilsUrl.LivraisonPosURL() + "/getDeliveryInformation/" + idUser
    );
  }
}
export default new ConfigLivraisonService();
